export const UserActionType = {
    LOGIN: 'user/login',
    LOGOUT: 'user/logout',
    CREATE: 'user/create',
    FORGOT_PASSWORD: 'user/forgot-password',
    TYPE_BENEFIT: 'user/type-benefit'
}